// extracted by mini-css-extract-plugin
module.exports = {"salesTypeButton":"salesTypeButton--804ba"};